// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xmQJ","newExpiryDate":"styles_newExpiryDate__2Rtx8","footer":"styles_footer__ETDmn"};